// extracted by mini-css-extract-plugin
export default {"button--search":"button--search__++cZl","active":"active__Ms2X9"};